import React from 'react';
import { Box, Inscription, ListItemField } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  title?: ListItemField['title'];
  value?: ListItemField['value'];
  node?: ListItemField['node'];
  style?: React.CSSProperties;
}

const CheckCardItem: React.FC<Props> = ({ testId, title, value, node, style }) => (
  <Box data-testid={`${testId}_cell`}>
    <Inscription
      data-testid={`${testId}_title`}
      size="12px"
      color="textBody"
      weight={700}
      lineHeight="18px"
    >
      {title}
    </Inscription>
    <Inscription
      data-testid={`${testId}_value`}
      title={value}
      size="14px"
      weight={400}
      color="textBody"
      lineHeight="20px"
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style,
      }}
    >
      {value || node}
    </Inscription>
  </Box>
);

export default CheckCardItem;
